<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">주차장 관리 - 주차장 설정
          <v-btn v-if="$store.state.userInfo && $store.state.userInfo.writeParking" depressed rounded outlined color="secondary" class="ml-5" @click="setCreateMode">
            <v-icon>add</v-icon> 주차장 추가
          </v-btn>
        </h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="parkingList && parkingList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(parking, idx) in parkingList"
                      :key="parking.id"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentParking(parking)"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ parking.name }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="parkingList && parkingList.length === 0">등록된 주차장이 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-if="parking && parking.id || mode === 'CREATE'"
                  >
                    <v-container>
                      <v-row class="pa-2">
                        <v-col cols="12" class="pa-0">
                          <v-text-field
                            v-model="parking.name"
                            label="주차장이름"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-select
                            :items="managerList"
                            label="담당자"
                            v-model="parking.manager"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-text-field
                            v-model="parking.size"
                            label="최대주차"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-text-field
                            v-model="parking.distance"
                            label="성전까지 거리(도보)"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-text-field
                            v-model="parking.charge"
                            label="요금"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-checkbox
                            v-model="parking.visible"
                            label="앱에 표시하기"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                          <v-row justify="start">
                            <v-subheader class="pa-0 form-label--separate with--button">주차장 입구 위경도</v-subheader>
                            <v-btn class="mx-2"  color="black" dark small rounded depressed  @click="entryModal = true">
                              위치
                              <v-icon small>map</v-icon>
                            </v-btn>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row justify="start">
                            <v-subheader class="pa-0 form-label--separate with--button">주차장 범위 위경도</v-subheader>
                            <v-btn class="mx-2"  color="black" dark small rounded depressed  @click="parkingModal = true">
                              위치
                              <v-icon small>map</v-icon>
                            </v-btn>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row justify="start">
                            <v-subheader class="pa-0 form-label--separate">사진 목록</v-subheader>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="pa-0 pb-5">
                          <carousel
                            :key="parking.id"
                            :imageObject.sync="parkingImage"
                            :is-show-remove-button="$store.state.userInfo && $store.state.userInfo.writeParking"
                          />
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-textarea
                            name="input-7-1"
                            label="설명 및 제한사항"
                            outlined
                            v-model="parking.comment"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeParking"
                            :disabled="!(parking.name || '').trim()"
                            color="primary"
                            class="mt-4"
                            rounded
                            depressed
                            @click="onSubmit"
                            large
                          >
                            {{ mode === 'CREATE' ? '등록하기' : '수정하기'}}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="mt-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeParking && parking.id"
                            color="error"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveParking">
                            <v-icon>remove</v-icon>
                            주차장제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 주차장이 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
    <!-- 주차장 입구 위경도 설정 팝업-->
    <v-dialog v-model="entryModal" fullscreen hide-overlay transition="dialog-bottom-transition" class="map-layer">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>주차장 입구 위경도 설정</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <map-pick
            v-if="entryModal"
            :location-data="parking.location"
            @closeModal="closeModal"
            @onSubmitMapPick="getLocation"
            :is-show-set-button="$store.state.userInfo && $store.state.userInfo.writeParking"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 주차장 범위 위경도 위치 설정 팝업-->
    <v-dialog v-model="parkingModal" fullscreen hide-overlay transition="dialog-bottom-transition" class="map-layer">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>주차장 범위 위경도 위치 설정</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <map-range
            v-if="parkingModal"
            :path-data="parking.ranges"
            @closeModal="closeModal"
            @onSubmitMapRange="getPath"
            :is-show-set-button="$store.state.userInfo && $store.state.userInfo.writeParking"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </article>
</template>

<script>
import { parking, manager, image } from '../api'
import eventBus from '../utils/eventBus'
import Carousel from '../components/common/Carousel'
import MapRange from '../components/map/MapRange'
import MapPick from '../components/map/MapPick'

export default {
  components: {
    Carousel, MapPick, MapRange
  },
  data: () => ({
    parkingList: null,
    managerList: [],
    parking: {
      id: 0,
      images: []
    },
    parkingImage: {
      images: [],
      deleteTarget: [],
      addTarget: []
    },
    mode: null,
    valid: true,
    // 추가
    entryModal: false,
    parkingModal: false,
    activeIndex: null
  }),
  created () {
    this.fetchList()
    this.fetchManagerList()
  },
  methods: {
    async fetchManagerList () {
      const { data } = await manager.list()
      this.managerList = data.map(x => {
        return {
          text: `${x.name} (${x.phone})`,
          value: x.id
        }
      }, [])
    },
    async fetchList () {
      const { data } = await parking.list()
      this.parkingList = data
    },
    async createParking () {
      await this.processAddImage()
      const { data } = await parking.create({
        ...this.parking,
        managerID: this.parking.manager
      })
      eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      await this.fetchList()
      this.setCurrentParking(data)
      this.activeIndex = this.parkingList.findIndex(x => x.id === data.id)
    },
    async updateParking () {
      await this.processAddImage()
      await this.processDeleteImage()
      const { data } = await parking.set(this.parking.id, {
        ...this.parking,
        managerID: this.parking.manager
      })
      this.setCurrentParking(data)
      eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
      await this.fetchList()
    },
    async processAddImage () {
      for (const i in this.parkingImage.addTarget) {
        const { data } = await image.create(this.makeFileFormData(this.parkingImage.addTarget[i].file))
        this.parking.images.push(data.name)
      }
    },
    processDeleteImage () {
      for (const i in this.parkingImage.deleteTarget) {
        const imageIndex = this.parking.images.indexOf(this.parkingImage.deleteTarget[i])
        this.parking.images.splice(imageIndex, 1)
      }
    },
    makeFileFormData (file) {
      const formData = new FormData()
      formData.append('sourceFile', file)
      return formData
    },
    setCreateMode () {
      this.parking = { id: 0, images: [] }
      this.mode = 'CREATE'
      this.parkingImage = {
        images: [],
        deleteTarget: [],
        addTarget: []
      }
      this.activeIndex = null
    },
    setCurrentParking (parking) {
      this.parking = { ...parking }
      this.parkingImage = {
        images: [],
        deleteTarget: [],
        addTarget: []
      }
      this.parkingImage.images = parking.images
      this.mode = 'UPDATE'
    },
    async onSubmit () {
      try {
        eventBus.$emit('showLoading')
        if (this.mode === 'CREATE') {
          await this.createParking()
        } else {
          await this.updateParking()
        }
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async onRemoveConfirm () {
      await parking.delete(this.parking.id)
      eventBus.$emit('alert', { active: true, text: '제거되었습니다.' })
      this.setCreateMode()
      await this.fetchList()
    },
    onRemoveParking () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '주차장을 정말 제거하시겠습니까?',
          okText: '주차장제거',
          confirmHandler: {
            ok: () => {
              this.onRemoveConfirm()
            }
          }
        }
      )
    },
    getPath (path) {
      this.parking.ranges = path
      eventBus.$emit('alert', { active: true, text: '주차장 범위 위경도가 설정 되었습니다.' })
      this.parkingModal = false
    },
    getLocation (location) {
      this.parking.location = location
      eventBus.$emit('alert', { active: true, text: '주차장 입구 위경도가 설정 되었습니다.' })
      this.entryModal = false
    },
    selectMainItem (index) {
      this.activeIndex = index
    },
    closeModal () {
      this.entryModal = false
      this.parkingModal = false
    }
  }
}
</script>

<style lang="scss">
</style>
